import React from 'react';
import {Section, Table, NameCell, ValueCell} from '../components/cells';
import {money, count} from '../model/format';

/** Proforma Rent Roll sheet: read-only; proforma rents are entered on the Current Rent Roll. */
export default function ProformaRentRoll({calc}) {
    const roll = calc.proformaRentRoll;
    const total = roll.total;

    return (
        <div className='mf-tab mf-rent-roll'>
            <Section title='Proforma Rent Roll' description='Proforma rent is entered on the Current Rent Roll'>
                <Table className='mf-grid-table mf-proforma-rent-roll-table'
                    header={['Floor Plan', 'Units', 'Proforma Rent/Mo', 'Monthly Proforma Rent', 'Annual Proforma Rent']}
                    footer={
                        <tr className='mf-total-row'>
                            <NameCell>{total.floor_plan}</NameCell>
                            <ValueCell>{count(total.units)}</ValueCell>
                            <ValueCell>{money(total.proforma_rent)}</ValueCell>
                            <ValueCell>{money(total.monthly_proforma_rent)}</ValueCell>
                            <ValueCell>{money(total.annual_proforma_rent)}</ValueCell>
                        </tr>
                    }
                >
                    {roll.rows.map((row, index) => (
                        <tr key={index}>
                            <NameCell>{row.floor_plan || '-'}</NameCell>
                            <ValueCell>{count(row.units)}</ValueCell>
                            <ValueCell>{money(row.proforma_rent)}</ValueCell>
                            <ValueCell>{money(row.monthly_proforma_rent)}</ValueCell>
                            <ValueCell>{money(row.annual_proforma_rent)}</ValueCell>
                        </tr>
                    ))}
                </Table>
            </Section>
        </div>
    );
}
